﻿/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AlbumCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: AlbumDto_Create | null | undefined): Observable<AlbumDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/AlbumCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<AlbumDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<AlbumDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AlbumDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AlbumDto_WithRelation.fromJS(resultData200) : new AlbumDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlbumDto_WithRelation>(<any>null);
    }

    /**
     * @param takeCount (optional) 
     * @return Success
     */
    loadAllAnonymouse(takeCount: number | null | undefined): Observable<AlbumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AlbumCrud/LoadAllAnonymouse?";
        if (takeCount !== undefined)
            url_ += "takeCount=" + encodeURIComponent("" + takeCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAllAnonymouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAllAnonymouse(<any>response_);
                } catch (e) {
                    return <Observable<AlbumDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AlbumDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAllAnonymouse(response: HttpResponseBase): Observable<AlbumDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AlbumDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlbumDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAllByPageAnonymouse(input: AlbumDto_LoadAll | null | undefined): Observable<PagedResultDtoOfAlbumDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/AlbumCrud/LoadAllByPageAnonymouse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAllByPageAnonymouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAllByPageAnonymouse(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAlbumDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAlbumDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAllByPageAnonymouse(response: HttpResponseBase): Observable<PagedResultDtoOfAlbumDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfAlbumDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfAlbumDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAlbumDto_WithRelation>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AlbumCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: AlbumDto_LoadAll | null | undefined): Observable<PagedResultDtoOfAlbumDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/AlbumCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAlbumDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAlbumDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfAlbumDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfAlbumDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfAlbumDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAlbumDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<AlbumDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/AlbumCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<AlbumDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<AlbumDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlbumDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AlbumDto_WithRelation.fromJS(resultData200) : new AlbumDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlbumDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfAlbumDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/AlbumCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAlbumDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAlbumDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfAlbumDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfAlbumDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfAlbumDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAlbumDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: AlbumDto_Update | null | undefined): Observable<AlbumDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/AlbumCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<AlbumDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<AlbumDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AlbumDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AlbumDto_WithRelation.fromJS(resultData200) : new AlbumDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlbumDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AlbumCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class BookCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: BookDto_Create | null | undefined): Observable<BookDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/BookCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<BookDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<BookDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BookDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BookDto_WithRelation.fromJS(resultData200) : new BookDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookDto_WithRelation>(<any>null);
    }

    /**
     * @param booktype (optional) 
     * @param takeCount (optional) 
     * @return Success
     */
    loadAllAnonymouse(booktype: Booktype | null | undefined, takeCount: number | null | undefined): Observable<BookDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BookCrud/LoadAllAnonymouse?";
        if (takeCount !== undefined)
            url_ += "takeCount=" + encodeURIComponent("" + takeCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(booktype);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAllAnonymouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAllAnonymouse(<any>response_);
                } catch (e) {
                    return <Observable<BookDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BookDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAllAnonymouse(response: HttpResponseBase): Observable<BookDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BookDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAllByType(input: BookDto_GetAllByType | null | undefined): Observable<PagedResultDtoOfBookDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/BookCrud/LoadAllByType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAllByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAllByType(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBookDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBookDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAllByType(response: HttpResponseBase): Observable<PagedResultDtoOfBookDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfBookDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfBookDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBookDto_WithRelation>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BookCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: BookDto_LoadAll | null | undefined): Observable<PagedResultDtoOfBookDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/BookCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBookDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBookDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfBookDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfBookDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfBookDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBookDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<BookDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/BookCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<BookDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<BookDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BookDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BookDto_WithRelation.fromJS(resultData200) : new BookDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfBookDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/BookCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBookDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBookDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfBookDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfBookDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfBookDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBookDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: BookDto_Update | null | undefined): Observable<BookDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/BookCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<BookDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<BookDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BookDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BookDto_WithRelation.fromJS(resultData200) : new BookDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BookCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class BookSubscriberCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: BookSubscriberDto_Create | null | undefined): Observable<BookSubscriberDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/BookSubscriberCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<BookSubscriberDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<BookSubscriberDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BookSubscriberDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BookSubscriberDto_WithRelation.fromJS(resultData200) : new BookSubscriberDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookSubscriberDto_WithRelation>(<any>null);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    unSubscribe(email: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BookSubscriberCrud/UnSubscribe?";
        if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnSubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnSubscribe(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUnSubscribe(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    subscribe(input: BookSubscriberDto_Create | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BookSubscriberCrud/Subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribe(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSubscribe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    keepSubscribe(email: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BookSubscriberCrud/KeepSubscribe?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKeepSubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKeepSubscribe(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processKeepSubscribe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    deleteSubscribe(email: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BookSubscriberCrud/DeleteSubscribe?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubscribe(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteSubscribe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BookSubscriberCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: BookSubscriberDto_LoadAll | null | undefined): Observable<PagedResultDtoOfBookSubscriberDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/BookSubscriberCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBookSubscriberDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBookSubscriberDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfBookSubscriberDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfBookSubscriberDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfBookSubscriberDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBookSubscriberDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<BookSubscriberDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/BookSubscriberCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<BookSubscriberDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<BookSubscriberDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BookSubscriberDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BookSubscriberDto_WithRelation.fromJS(resultData200) : new BookSubscriberDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookSubscriberDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfBookSubscriberDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/BookSubscriberCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBookSubscriberDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBookSubscriberDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfBookSubscriberDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfBookSubscriberDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfBookSubscriberDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBookSubscriberDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: BookSubscriberDto_Update | null | undefined): Observable<BookSubscriberDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/BookSubscriberCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<BookSubscriberDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<BookSubscriberDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BookSubscriberDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BookSubscriberDto_WithRelation.fromJS(resultData200) : new BookSubscriberDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookSubscriberDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BookSubscriberCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class EmailNotifyLoggerCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailNotifyLoggerCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: EmailNotifyLoggerDto_LoadAll | null | undefined): Observable<PagedResultDtoOfEmailNotifyLoggerDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/EmailNotifyLoggerCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEmailNotifyLoggerDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEmailNotifyLoggerDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfEmailNotifyLoggerDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfEmailNotifyLoggerDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfEmailNotifyLoggerDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEmailNotifyLoggerDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<EmailNotifyLoggerDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/EmailNotifyLoggerCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<EmailNotifyLoggerDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailNotifyLoggerDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EmailNotifyLoggerDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EmailNotifyLoggerDto_WithRelation.fromJS(resultData200) : new EmailNotifyLoggerDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailNotifyLoggerDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfEmailNotifyLoggerDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/EmailNotifyLoggerCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEmailNotifyLoggerDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEmailNotifyLoggerDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfEmailNotifyLoggerDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfEmailNotifyLoggerDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfEmailNotifyLoggerDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEmailNotifyLoggerDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: EmailNotifyLoggerDto_Create | null | undefined): Observable<EmailNotifyLoggerDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/EmailNotifyLoggerCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<EmailNotifyLoggerDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailNotifyLoggerDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<EmailNotifyLoggerDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EmailNotifyLoggerDto_WithRelation.fromJS(resultData200) : new EmailNotifyLoggerDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailNotifyLoggerDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: EmailNotifyLoggerDto_Update | null | undefined): Observable<EmailNotifyLoggerDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/EmailNotifyLoggerCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<EmailNotifyLoggerDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailNotifyLoggerDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<EmailNotifyLoggerDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EmailNotifyLoggerDto_WithRelation.fromJS(resultData200) : new EmailNotifyLoggerDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailNotifyLoggerDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailNotifyLoggerCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class EmailSendingLogCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    sendMailImd(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailSendingLogCrud/SendMailImd";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailImd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailImd(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendMailImd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailSendingLogCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: EmailSendingLogDto_LoadAll | null | undefined): Observable<PagedResultDtoOfEmailSendingLogDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/EmailSendingLogCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEmailSendingLogDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEmailSendingLogDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfEmailSendingLogDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfEmailSendingLogDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfEmailSendingLogDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEmailSendingLogDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<EmailSendingLogDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/EmailSendingLogCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<EmailSendingLogDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailSendingLogDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EmailSendingLogDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EmailSendingLogDto_WithRelation.fromJS(resultData200) : new EmailSendingLogDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailSendingLogDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfEmailSendingLogDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/EmailSendingLogCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEmailSendingLogDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEmailSendingLogDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfEmailSendingLogDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfEmailSendingLogDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfEmailSendingLogDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEmailSendingLogDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: EmailSendingLogDto_Create | null | undefined): Observable<EmailSendingLogDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/EmailSendingLogCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<EmailSendingLogDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailSendingLogDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<EmailSendingLogDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EmailSendingLogDto_WithRelation.fromJS(resultData200) : new EmailSendingLogDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailSendingLogDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: EmailSendingLogDto_Update | null | undefined): Observable<EmailSendingLogDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/EmailSendingLogCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<EmailSendingLogDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailSendingLogDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<EmailSendingLogDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EmailSendingLogDto_WithRelation.fromJS(resultData200) : new EmailSendingLogDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailSendingLogDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailSendingLogCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FormRecordUploadServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    importFormRecord(): Observable<ImportFormErrorLogDto[]> {
        let url_ = this.baseUrl + "/api/FormRecordUpload/ImportFormRecord";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportFormRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportFormRecord(<any>response_);
                } catch (e) {
                    return <Observable<ImportFormErrorLogDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportFormErrorLogDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processImportFormRecord(response: HttpResponseBase): Observable<ImportFormErrorLogDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ImportFormErrorLogDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportFormErrorLogDto[]>(<any>null);
    }

    /**
     * @param formDocId (optional) 
     * @return Success
     */
    exportExample(formDocId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FormRecordUpload/ExportExample";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formDocId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExample(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportExample(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MailingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param mailId (optional) 
     * @param emails (optional) 
     * @return Success
     */
    sendToEmails(mailId: number | null | undefined, emails: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Mailing/SendToEmails?";
        if (mailId !== undefined)
            url_ += "mailId=" + encodeURIComponent("" + mailId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emails);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendToEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendToEmails(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendToEmails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param mailId (optional) 
     * @return Success
     */
    testSend(mailId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Mailing/TestSend?";
        if (mailId !== undefined)
            url_ += "mailId=" + encodeURIComponent("" + mailId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestSend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestSend(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTestSend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param bookId (optional) 
     * @return Success
     */
    sendToSubscribers(bookId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Mailing/SendToSubscribers?";
        if (bookId !== undefined)
            url_ += "bookId=" + encodeURIComponent("" + bookId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendToSubscribers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendToSubscribers(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendToSubscribers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param bookId (optional) 
     * @param mail (optional) 
     * @param message (optional) 
     * @return Success
     */
    testSendToSubscribers(bookId: number | null | undefined, mail: string | null | undefined, message: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Mailing/TestSendToSubscribers?";
        if (bookId !== undefined)
            url_ += "bookId=" + encodeURIComponent("" + bookId) + "&"; 
        if (mail !== undefined)
            url_ += "mail=" + encodeURIComponent("" + mail) + "&"; 
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestSendToSubscribers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestSendToSubscribers(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTestSendToSubscribers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    notifyUser(input: MailMessageDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Mailing/NotifyUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processNotifyUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    notifyDisabledUser(input: MailMessageDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Mailing/NotifyDisabledUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyDisabledUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyDisabledUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processNotifyDisabledUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MemberSubscribeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    keepSubscribe(email: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/MemberSubscribe/KeepSubscribe?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKeepSubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKeepSubscribe(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processKeepSubscribe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    deleteSubscribe(email: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/MemberSubscribe/DeleteSubscribe?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubscribe(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteSubscribe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RecordTimeStampCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param stampType (optional) 
     * @param datestring (optional) 
     * @return Success
     */
    getRecordByMonth(stampType: StampType | null | undefined, datestring: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/RecordTimeStampCrud/GetRecordByMonth?";
        if (stampType !== undefined)
            url_ += "stampType=" + encodeURIComponent("" + stampType) + "&"; 
        if (datestring !== undefined)
            url_ += "datestring=" + encodeURIComponent("" + datestring) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecordByMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecordByMonth(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecordByMonth(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RecordTimeStampCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: RecordTimeStampDto_LoadAll | null | undefined): Observable<PagedResultDtoOfRecordTimeStampDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/RecordTimeStampCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRecordTimeStampDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRecordTimeStampDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfRecordTimeStampDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfRecordTimeStampDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfRecordTimeStampDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRecordTimeStampDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<RecordTimeStampDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/RecordTimeStampCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RecordTimeStampDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordTimeStampDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RecordTimeStampDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RecordTimeStampDto_WithRelation.fromJS(resultData200) : new RecordTimeStampDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecordTimeStampDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfRecordTimeStampDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/RecordTimeStampCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRecordTimeStampDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRecordTimeStampDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfRecordTimeStampDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfRecordTimeStampDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfRecordTimeStampDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRecordTimeStampDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: RecordTimeStampDto_Create | null | undefined): Observable<RecordTimeStampDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/RecordTimeStampCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RecordTimeStampDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordTimeStampDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RecordTimeStampDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RecordTimeStampDto_WithRelation.fromJS(resultData200) : new RecordTimeStampDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecordTimeStampDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: RecordTimeStampDto_Update | null | undefined): Observable<RecordTimeStampDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/RecordTimeStampCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RecordTimeStampDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordTimeStampDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RecordTimeStampDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RecordTimeStampDto_WithRelation.fromJS(resultData200) : new RecordTimeStampDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecordTimeStampDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RecordTimeStampCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RegulationCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: RegulationDto_Create | null | undefined): Observable<RegulationDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/RegulationCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RegulationDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegulationDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RegulationDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegulationDto_WithRelation.fromJS(resultData200) : new RegulationDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegulationDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: RegulationDto_Update | null | undefined): Observable<RegulationDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/RegulationCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RegulationDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegulationDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RegulationDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegulationDto_WithRelation.fromJS(resultData200) : new RegulationDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegulationDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RegulationCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllRoot(): Observable<RegulationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RegulationCrud/GetAllRoot";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRoot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRoot(<any>response_);
                } catch (e) {
                    return <Observable<RegulationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegulationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRoot(response: HttpResponseBase): Observable<RegulationDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RegulationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegulationDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAllChildByParentId(id: number | null | undefined): Observable<RegulationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RegulationCrud/GetAllChildByParentId?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllChildByParentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllChildByParentId(<any>response_);
                } catch (e) {
                    return <Observable<RegulationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegulationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllChildByParentId(response: HttpResponseBase): Observable<RegulationDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RegulationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegulationDto[]>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RegulationCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: RegulationDto_LoadAll | null | undefined): Observable<PagedResultDtoOfRegulationDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/RegulationCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRegulationDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRegulationDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfRegulationDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfRegulationDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfRegulationDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRegulationDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<RegulationDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/RegulationCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RegulationDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegulationDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RegulationDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegulationDto_WithRelation.fromJS(resultData200) : new RegulationDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegulationDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfRegulationDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/RegulationCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRegulationDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRegulationDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfRegulationDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfRegulationDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfRegulationDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRegulationDto_WithRelation>(<any>null);
    }
}

@Injectable()
export class SettingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param settings (optional) 
     * @return Success
     */
    save(settings: SettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Setting/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    load(): Observable<SettingDto> {
        let url_ = this.baseUrl + "/api/services/app/Setting/Load";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoad(<any>response_);
                } catch (e) {
                    return <Observable<SettingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SettingDto>><any>_observableThrow(response_);
        }));
    }

    protected processLoad(response: HttpResponseBase): Observable<SettingDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SettingDto.fromJS(resultData200) : new SettingDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SettingDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    saveRecordTimeStamp(input: DateTimeValueDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Setting/SaveRecordTimeStamp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRecordTimeStamp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRecordTimeStamp(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSaveRecordTimeStamp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    loadRecordTimeStamp(): Observable<DateTimeValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Setting/LoadRecordTimeStamp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadRecordTimeStamp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadRecordTimeStamp(<any>response_);
                } catch (e) {
                    return <Observable<DateTimeValueDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DateTimeValueDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processLoadRecordTimeStamp(response: HttpResponseBase): Observable<DateTimeValueDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DateTimeValueDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateTimeValueDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    addVisitorCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Setting/AddVisitorCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddVisitorCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddVisitorCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processAddVisitorCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

@Injectable()
export class StationAppServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param docId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return Success
     */
    getRecordAndStationByDocId(docId: number | null | undefined, startTime: string | null | undefined, endTime: string | null | undefined): Observable<FormStationRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StationApp/GetRecordAndStationByDocId?";
        if (docId !== undefined)
            url_ += "DocId=" + encodeURIComponent("" + docId) + "&"; 
        if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent("" + startTime) + "&"; 
        if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent("" + endTime) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecordAndStationByDocId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecordAndStationByDocId(<any>response_);
                } catch (e) {
                    return <Observable<FormStationRecordDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormStationRecordDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecordAndStationByDocId(response: HttpResponseBase): Observable<FormStationRecordDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FormStationRecordDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormStationRecordDto[]>(<any>null);
    }

    /**
     * @param no (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return Success
     */
    getRecordAndStationByNo(no: string | null | undefined, startTime: string | null | undefined, endTime: string | null | undefined): Observable<MultipleDocRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StationApp/GetRecordAndStationByNo?";
        if (no !== undefined)
            url_ += "no=" + encodeURIComponent("" + no) + "&"; 
        if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent("" + startTime) + "&"; 
        if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent("" + endTime) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecordAndStationByNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecordAndStationByNo(<any>response_);
                } catch (e) {
                    return <Observable<MultipleDocRecordDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MultipleDocRecordDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecordAndStationByNo(response: HttpResponseBase): Observable<MultipleDocRecordDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MultipleDocRecordDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MultipleDocRecordDto[]>(<any>null);
    }

    /**
     * @param no (optional) 
     * @return Success
     */
    getStationDateArray(no: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/StationApp/GetStationDateArray?";
        if (no !== undefined)
            url_ += "no=" + encodeURIComponent("" + no) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStationDateArray(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStationDateArray(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetStationDateArray(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param no (optional) 
     * @return Success
     */
    getRecordFormItemByNo(no: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/StationApp/GetRecordFormItemByNo?";
        if (no !== undefined)
            url_ += "no=" + encodeURIComponent("" + no) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecordFormItemByNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecordFormItemByNo(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecordFormItemByNo(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }
}

@Injectable()
export class StationCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchStation(input: SearchStationDto | null | undefined): Observable<PagedResultDtoOfStationDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/StationCrud/SearchStation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchStation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchStation(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStationDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStationDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processSearchStation(response: HttpResponseBase): Observable<PagedResultDtoOfStationDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfStationDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfStationDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStationDto_WithRelation>(<any>null);
    }

    /**
     * @return Success
     */
    getMaxNo(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/StationCrud/GetMaxNo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaxNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaxNo(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetMaxNo(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StationCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: StationDto_LoadAll | null | undefined): Observable<PagedResultDtoOfStationDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/StationCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStationDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStationDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfStationDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfStationDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfStationDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStationDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<StationDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/StationCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<StationDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<StationDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StationDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StationDto_WithRelation.fromJS(resultData200) : new StationDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StationDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfStationDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/StationCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStationDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStationDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfStationDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfStationDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfStationDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStationDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: StationDto_Create | null | undefined): Observable<StationDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/StationCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<StationDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<StationDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<StationDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StationDto_WithRelation.fromJS(resultData200) : new StationDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StationDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: StationDto_Update | null | undefined): Observable<StationDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/StationCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<StationDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<StationDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<StationDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StationDto_WithRelation.fromJS(resultData200) : new StationDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StationDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StationCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class StationRecordCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param recordId (optional) 
     * @return Success
     */
    deleteByRecordId(recordId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StationRecordCrud/DeleteByRecordId?";
        if (recordId !== undefined)
            url_ += "RecordId=" + encodeURIComponent("" + recordId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByRecordId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByRecordId(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByRecordId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param recordId (optional) 
     * @return Success
     */
    getStationRecordByRecordId(recordId: number | null | undefined): Observable<StationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/StationRecordCrud/GetStationRecordByRecordId?";
        if (recordId !== undefined)
            url_ += "RecordId=" + encodeURIComponent("" + recordId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStationRecordByRecordId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStationRecordByRecordId(<any>response_);
                } catch (e) {
                    return <Observable<StationRecordDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StationRecordDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStationRecordByRecordId(response: HttpResponseBase): Observable<StationRecordDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StationRecordDto.fromJS(resultData200) : new StationRecordDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StationRecordDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    stationWithRecord(input: StationRecordDto_LoadAll | null | undefined): Observable<PagedResultDtoOfStationWithRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/StationRecordCrud/StationWithRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStationWithRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStationWithRecord(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStationWithRecordDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStationWithRecordDto>><any>_observableThrow(response_);
        }));
    }

    protected processStationWithRecord(response: HttpResponseBase): Observable<PagedResultDtoOfStationWithRecordDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfStationWithRecordDto.fromJS(resultData200) : new PagedResultDtoOfStationWithRecordDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStationWithRecordDto>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StationRecordCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: StationRecordDto_LoadAll | null | undefined): Observable<PagedResultDtoOfStationRecordDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/StationRecordCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStationRecordDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStationRecordDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfStationRecordDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfStationRecordDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfStationRecordDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStationRecordDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<StationRecordDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/StationRecordCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<StationRecordDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<StationRecordDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StationRecordDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StationRecordDto_WithRelation.fromJS(resultData200) : new StationRecordDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StationRecordDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfStationRecordDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/StationRecordCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStationRecordDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStationRecordDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfStationRecordDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfStationRecordDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfStationRecordDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStationRecordDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: StationRecordDto_Create | null | undefined): Observable<StationRecordDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/StationRecordCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<StationRecordDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<StationRecordDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<StationRecordDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StationRecordDto_WithRelation.fromJS(resultData200) : new StationRecordDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StationRecordDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: StationRecordDto_Update | null | undefined): Observable<StationRecordDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/StationRecordCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<StationRecordDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<StationRecordDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<StationRecordDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StationRecordDto_WithRelation.fromJS(resultData200) : new StationRecordDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StationRecordDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StationRecordCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class BookServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    uploadBookEmailCover(): Observable<void> {
        let url_ = this.baseUrl + "/api/Book/UploadBookEmailCover";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBookEmailCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBookEmailCover(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUploadBookEmailCover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    uploadBookFile(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Book/UploadBookFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBookFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBookFile(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processUploadBookFile(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param urls (optional) 
     * @return Success
     */
    deleteBookFile(urls: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Book/DeleteBookFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(urls);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBookFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBookFile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteBookFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param urls (optional) 
     * @return Success
     */
    deleteBookEmailCover(urls: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Book/DeleteBookEmailCover";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(urls);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBookEmailCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBookEmailCover(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteBookEmailCover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteBookDirectory(ids: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Book/DeleteBookDirectory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBookDirectory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBookDirectory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteBookDirectory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ActivityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    uploadActivityFile(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Activity/UploadActivityFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadActivityFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadActivityFile(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processUploadActivityFile(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param urls (optional) 
     * @return Success
     */
    deleteActivityFile(urls: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Activity/DeleteActivityFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(urls);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteActivityFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteActivityFile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteActivityFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteActivityDirectory(ids: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Activity/DeleteActivityDirectory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteActivityDirectory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteActivityDirectory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteActivityDirectory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export class AlbumDto_Create implements IAlbumDto_Create {
    id: number | undefined;
    title: string | undefined;
    description: string | undefined;
    sequence: number | undefined;
    photoFields: PhotoField[] | undefined;

    constructor(data?: IAlbumDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.description = data["description"];
            this.sequence = data["sequence"];
            if (data["photoFields"] && data["photoFields"].constructor === Array) {
                this.photoFields = [] as any;
                for (let item of data["photoFields"])
                    this.photoFields.push(PhotoField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlbumDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new AlbumDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["sequence"] = this.sequence;
        if (this.photoFields && this.photoFields.constructor === Array) {
            data["photoFields"] = [];
            for (let item of this.photoFields)
                data["photoFields"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AlbumDto_Create {
        const json = this.toJSON();
        let result = new AlbumDto_Create();
        result.init(json);
        return result;
    }
}

export interface IAlbumDto_Create {
    id: number | undefined;
    title: string | undefined;
    description: string | undefined;
    sequence: number | undefined;
    photoFields: PhotoField[] | undefined;
}

export class PhotoField implements IPhotoField {
    title: string | undefined;
    url: string | undefined;
    width: number | undefined;
    height: number | undefined;
    isCover: boolean | undefined;

    constructor(data?: IPhotoField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.url = data["url"];
            this.width = data["width"];
            this.height = data["height"];
            this.isCover = data["isCover"];
        }
    }

    static fromJS(data: any): PhotoField {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["url"] = this.url;
        data["width"] = this.width;
        data["height"] = this.height;
        data["isCover"] = this.isCover;
        return data; 
    }

    clone(): PhotoField {
        const json = this.toJSON();
        let result = new PhotoField();
        result.init(json);
        return result;
    }
}

export interface IPhotoField {
    title: string | undefined;
    url: string | undefined;
    width: number | undefined;
    height: number | undefined;
    isCover: boolean | undefined;
}

export class AlbumDto_WithRelation implements IAlbumDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    title: string | undefined;
    description: string | undefined;
    sequence: number | undefined;
    photoFields: PhotoField[] | undefined;

    constructor(data?: IAlbumDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.id = data["id"];
            this.title = data["title"];
            this.description = data["description"];
            this.sequence = data["sequence"];
            if (data["photoFields"] && data["photoFields"].constructor === Array) {
                this.photoFields = [] as any;
                for (let item of data["photoFields"])
                    this.photoFields.push(PhotoField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlbumDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new AlbumDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["sequence"] = this.sequence;
        if (this.photoFields && this.photoFields.constructor === Array) {
            data["photoFields"] = [];
            for (let item of this.photoFields)
                data["photoFields"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AlbumDto_WithRelation {
        const json = this.toJSON();
        let result = new AlbumDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IAlbumDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    title: string | undefined;
    description: string | undefined;
    sequence: number | undefined;
    photoFields: PhotoField[] | undefined;
}

export class FullAuditedDto implements IFullAuditedDto {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;

    constructor(data?: IFullAuditedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
        }
    }

    static fromJS(data: any): FullAuditedDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullAuditedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data; 
    }

    clone(): FullAuditedDto {
        const json = this.toJSON();
        let result = new FullAuditedDto();
        result.init(json);
        return result;
    }
}

export interface IFullAuditedDto {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;
}

export class AlbumDto implements IAlbumDto {
    id: number | undefined;
    title: string | undefined;
    description: string | undefined;
    sequence: number | undefined;
    photoFields: PhotoField[] | undefined;

    constructor(data?: IAlbumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.description = data["description"];
            this.sequence = data["sequence"];
            if (data["photoFields"] && data["photoFields"].constructor === Array) {
                this.photoFields = [] as any;
                for (let item of data["photoFields"])
                    this.photoFields.push(PhotoField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlbumDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlbumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["sequence"] = this.sequence;
        if (this.photoFields && this.photoFields.constructor === Array) {
            data["photoFields"] = [];
            for (let item of this.photoFields)
                data["photoFields"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AlbumDto {
        const json = this.toJSON();
        let result = new AlbumDto();
        result.init(json);
        return result;
    }
}

export interface IAlbumDto {
    id: number | undefined;
    title: string | undefined;
    description: string | undefined;
    sequence: number | undefined;
    photoFields: PhotoField[] | undefined;
}

export class AlbumDto_LoadAll implements IAlbumDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IAlbumDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): AlbumDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new AlbumDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): AlbumDto_LoadAll {
        const json = this.toJSON();
        let result = new AlbumDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IAlbumDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfAlbumDto_WithRelation implements IPagedResultDtoOfAlbumDto_WithRelation {
    totalCount: number | undefined;
    items: AlbumDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfAlbumDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(AlbumDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAlbumDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAlbumDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfAlbumDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAlbumDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAlbumDto_WithRelation {
    totalCount: number | undefined;
    items: AlbumDto_WithRelation[] | undefined;
}

export class AlbumDto_Update implements IAlbumDto_Update {
    id: number | undefined;
    title: string | undefined;
    description: string | undefined;
    sequence: number | undefined;
    photoFields: PhotoField[] | undefined;

    constructor(data?: IAlbumDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.description = data["description"];
            this.sequence = data["sequence"];
            if (data["photoFields"] && data["photoFields"].constructor === Array) {
                this.photoFields = [] as any;
                for (let item of data["photoFields"])
                    this.photoFields.push(PhotoField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlbumDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new AlbumDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["sequence"] = this.sequence;
        if (this.photoFields && this.photoFields.constructor === Array) {
            data["photoFields"] = [];
            for (let item of this.photoFields)
                data["photoFields"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AlbumDto_Update {
        const json = this.toJSON();
        let result = new AlbumDto_Update();
        result.init(json);
        return result;
    }
}

export interface IAlbumDto_Update {
    id: number | undefined;
    title: string | undefined;
    description: string | undefined;
    sequence: number | undefined;
    photoFields: PhotoField[] | undefined;
}

export class BookDto_Create implements IBookDto_Create {
    id: number | undefined;
    title: string | undefined;
    bookInfo: BookInfoDto | undefined;
    lastSendTime: Date | undefined;
    bookType: BookDto_CreateBookType | undefined;
    sequence: number | undefined;
    emailContent: string | undefined;
    coverField: PhotoField | undefined;
    pdfField: PdfField | undefined;
    emailField: PhotoField[] | undefined;

    constructor(data?: IBookDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.bookInfo = data["bookInfo"] ? BookInfoDto.fromJS(data["bookInfo"]) : <any>undefined;
            this.lastSendTime = data["lastSendTime"] ? new Date(data["lastSendTime"].toString()) : <any>undefined;
            this.bookType = data["bookType"];
            this.sequence = data["sequence"];
            this.emailContent = data["emailContent"];
            this.coverField = data["coverField"] ? PhotoField.fromJS(data["coverField"]) : <any>undefined;
            this.pdfField = data["pdfField"] ? PdfField.fromJS(data["pdfField"]) : <any>undefined;
            if (data["emailField"] && data["emailField"].constructor === Array) {
                this.emailField = [] as any;
                for (let item of data["emailField"])
                    this.emailField.push(PhotoField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new BookDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["bookInfo"] = this.bookInfo ? this.bookInfo.toJSON() : <any>undefined;
        data["lastSendTime"] = this.lastSendTime ? this.lastSendTime.toISOString() : <any>undefined;
        data["bookType"] = this.bookType;
        data["sequence"] = this.sequence;
        data["emailContent"] = this.emailContent;
        data["coverField"] = this.coverField ? this.coverField.toJSON() : <any>undefined;
        data["pdfField"] = this.pdfField ? this.pdfField.toJSON() : <any>undefined;
        if (this.emailField && this.emailField.constructor === Array) {
            data["emailField"] = [];
            for (let item of this.emailField)
                data["emailField"].push(item.toJSON());
        }
        return data; 
    }

    clone(): BookDto_Create {
        const json = this.toJSON();
        let result = new BookDto_Create();
        result.init(json);
        return result;
    }
}

export interface IBookDto_Create {
    id: number | undefined;
    title: string | undefined;
    bookInfo: BookInfoDto | undefined;
    lastSendTime: Date | undefined;
    bookType: BookDto_CreateBookType | undefined;
    sequence: number | undefined;
    emailContent: string | undefined;
    coverField: PhotoField | undefined;
    pdfField: PdfField | undefined;
    emailField: PhotoField[] | undefined;
}

export class BookInfoDto implements IBookInfoDto {
    發行人: string | undefined;
    總編輯: string | undefined;
    副總編輯: string | undefined;
    編審委員: string | undefined;
    企劃督導: string | undefined;
    發行: string | undefined;
    地址: string | undefined;
    電話: string | undefined;
    傳真: string | undefined;
    發行時間: string | undefined;

    constructor(data?: IBookInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.發行人 = data["發行人"];
            this.總編輯 = data["總編輯"];
            this.副總編輯 = data["副總編輯"];
            this.編審委員 = data["編審委員"];
            this.企劃督導 = data["企劃督導"];
            this.發行 = data["發行"];
            this.地址 = data["地址"];
            this.電話 = data["電話"];
            this.傳真 = data["傳真"];
            this.發行時間 = data["發行時間"];
        }
    }

    static fromJS(data: any): BookInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["發行人"] = this.發行人;
        data["總編輯"] = this.總編輯;
        data["副總編輯"] = this.副總編輯;
        data["編審委員"] = this.編審委員;
        data["企劃督導"] = this.企劃督導;
        data["發行"] = this.發行;
        data["地址"] = this.地址;
        data["電話"] = this.電話;
        data["傳真"] = this.傳真;
        data["發行時間"] = this.發行時間;
        return data; 
    }

    clone(): BookInfoDto {
        const json = this.toJSON();
        let result = new BookInfoDto();
        result.init(json);
        return result;
    }
}

export interface IBookInfoDto {
    發行人: string | undefined;
    總編輯: string | undefined;
    副總編輯: string | undefined;
    編審委員: string | undefined;
    企劃督導: string | undefined;
    發行: string | undefined;
    地址: string | undefined;
    電話: string | undefined;
    傳真: string | undefined;
    發行時間: string | undefined;
}

export class PdfField implements IPdfField {
    title: string | undefined;
    url: string | undefined;
    size: string | undefined;
    fileType: string | undefined;

    constructor(data?: IPdfField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.url = data["url"];
            this.size = data["size"];
            this.fileType = data["fileType"];
        }
    }

    static fromJS(data: any): PdfField {
        data = typeof data === 'object' ? data : {};
        let result = new PdfField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["url"] = this.url;
        data["size"] = this.size;
        data["fileType"] = this.fileType;
        return data; 
    }

    clone(): PdfField {
        const json = this.toJSON();
        let result = new PdfField();
        result.init(json);
        return result;
    }
}

export interface IPdfField {
    title: string | undefined;
    url: string | undefined;
    size: string | undefined;
    fileType: string | undefined;
}

export class BookDto_WithRelation implements IBookDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    title: string | undefined;
    bookInfo: BookInfoDto | undefined;
    lastSendTime: Date | undefined;
    bookType: BookDto_WithRelationBookType | undefined;
    sequence: number | undefined;
    emailContent: string | undefined;
    coverField: PhotoField | undefined;
    pdfField: PdfField | undefined;
    emailField: PhotoField[] | undefined;

    constructor(data?: IBookDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.id = data["id"];
            this.title = data["title"];
            this.bookInfo = data["bookInfo"] ? BookInfoDto.fromJS(data["bookInfo"]) : <any>undefined;
            this.lastSendTime = data["lastSendTime"] ? new Date(data["lastSendTime"].toString()) : <any>undefined;
            this.bookType = data["bookType"];
            this.sequence = data["sequence"];
            this.emailContent = data["emailContent"];
            this.coverField = data["coverField"] ? PhotoField.fromJS(data["coverField"]) : <any>undefined;
            this.pdfField = data["pdfField"] ? PdfField.fromJS(data["pdfField"]) : <any>undefined;
            if (data["emailField"] && data["emailField"].constructor === Array) {
                this.emailField = [] as any;
                for (let item of data["emailField"])
                    this.emailField.push(PhotoField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new BookDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["title"] = this.title;
        data["bookInfo"] = this.bookInfo ? this.bookInfo.toJSON() : <any>undefined;
        data["lastSendTime"] = this.lastSendTime ? this.lastSendTime.toISOString() : <any>undefined;
        data["bookType"] = this.bookType;
        data["sequence"] = this.sequence;
        data["emailContent"] = this.emailContent;
        data["coverField"] = this.coverField ? this.coverField.toJSON() : <any>undefined;
        data["pdfField"] = this.pdfField ? this.pdfField.toJSON() : <any>undefined;
        if (this.emailField && this.emailField.constructor === Array) {
            data["emailField"] = [];
            for (let item of this.emailField)
                data["emailField"].push(item.toJSON());
        }
        return data; 
    }

    clone(): BookDto_WithRelation {
        const json = this.toJSON();
        let result = new BookDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IBookDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    title: string | undefined;
    bookInfo: BookInfoDto | undefined;
    lastSendTime: Date | undefined;
    bookType: BookDto_WithRelationBookType | undefined;
    sequence: number | undefined;
    emailContent: string | undefined;
    coverField: PhotoField | undefined;
    pdfField: PdfField | undefined;
    emailField: PhotoField[] | undefined;
}

export class BookDto implements IBookDto {
    id: number | undefined;
    title: string | undefined;
    bookInfo: BookInfoDto | undefined;
    lastSendTime: Date | undefined;
    bookType: BookDtoBookType | undefined;
    sequence: number | undefined;
    emailContent: string | undefined;
    coverField: PhotoField | undefined;
    pdfField: PdfField | undefined;
    emailField: PhotoField[] | undefined;

    constructor(data?: IBookDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.bookInfo = data["bookInfo"] ? BookInfoDto.fromJS(data["bookInfo"]) : <any>undefined;
            this.lastSendTime = data["lastSendTime"] ? new Date(data["lastSendTime"].toString()) : <any>undefined;
            this.bookType = data["bookType"];
            this.sequence = data["sequence"];
            this.emailContent = data["emailContent"];
            this.coverField = data["coverField"] ? PhotoField.fromJS(data["coverField"]) : <any>undefined;
            this.pdfField = data["pdfField"] ? PdfField.fromJS(data["pdfField"]) : <any>undefined;
            if (data["emailField"] && data["emailField"].constructor === Array) {
                this.emailField = [] as any;
                for (let item of data["emailField"])
                    this.emailField.push(PhotoField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["bookInfo"] = this.bookInfo ? this.bookInfo.toJSON() : <any>undefined;
        data["lastSendTime"] = this.lastSendTime ? this.lastSendTime.toISOString() : <any>undefined;
        data["bookType"] = this.bookType;
        data["sequence"] = this.sequence;
        data["emailContent"] = this.emailContent;
        data["coverField"] = this.coverField ? this.coverField.toJSON() : <any>undefined;
        data["pdfField"] = this.pdfField ? this.pdfField.toJSON() : <any>undefined;
        if (this.emailField && this.emailField.constructor === Array) {
            data["emailField"] = [];
            for (let item of this.emailField)
                data["emailField"].push(item.toJSON());
        }
        return data; 
    }

    clone(): BookDto {
        const json = this.toJSON();
        let result = new BookDto();
        result.init(json);
        return result;
    }
}

export interface IBookDto {
    id: number | undefined;
    title: string | undefined;
    bookInfo: BookInfoDto | undefined;
    lastSendTime: Date | undefined;
    bookType: BookDtoBookType | undefined;
    sequence: number | undefined;
    emailContent: string | undefined;
    coverField: PhotoField | undefined;
    pdfField: PdfField | undefined;
    emailField: PhotoField[] | undefined;
}

export class BookDto_GetAllByType implements IBookDto_GetAllByType {
    bookType: BookDto_GetAllByTypeBookType | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IBookDto_GetAllByType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookType = data["bookType"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): BookDto_GetAllByType {
        data = typeof data === 'object' ? data : {};
        let result = new BookDto_GetAllByType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookType"] = this.bookType;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): BookDto_GetAllByType {
        const json = this.toJSON();
        let result = new BookDto_GetAllByType();
        result.init(json);
        return result;
    }
}

export interface IBookDto_GetAllByType {
    bookType: BookDto_GetAllByTypeBookType | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfBookDto_WithRelation implements IPagedResultDtoOfBookDto_WithRelation {
    totalCount: number | undefined;
    items: BookDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfBookDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(BookDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBookDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBookDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfBookDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfBookDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfBookDto_WithRelation {
    totalCount: number | undefined;
    items: BookDto_WithRelation[] | undefined;
}

export class BookDto_LoadAll implements IBookDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IBookDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): BookDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new BookDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): BookDto_LoadAll {
        const json = this.toJSON();
        let result = new BookDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IBookDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class BookDto_Update implements IBookDto_Update {
    id: number | undefined;
    title: string | undefined;
    bookInfo: BookInfoDto | undefined;
    lastSendTime: Date | undefined;
    bookType: BookDto_UpdateBookType | undefined;
    sequence: number | undefined;
    emailContent: string | undefined;
    coverField: PhotoField | undefined;
    pdfField: PdfField | undefined;
    emailField: PhotoField[] | undefined;

    constructor(data?: IBookDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.bookInfo = data["bookInfo"] ? BookInfoDto.fromJS(data["bookInfo"]) : <any>undefined;
            this.lastSendTime = data["lastSendTime"] ? new Date(data["lastSendTime"].toString()) : <any>undefined;
            this.bookType = data["bookType"];
            this.sequence = data["sequence"];
            this.emailContent = data["emailContent"];
            this.coverField = data["coverField"] ? PhotoField.fromJS(data["coverField"]) : <any>undefined;
            this.pdfField = data["pdfField"] ? PdfField.fromJS(data["pdfField"]) : <any>undefined;
            if (data["emailField"] && data["emailField"].constructor === Array) {
                this.emailField = [] as any;
                for (let item of data["emailField"])
                    this.emailField.push(PhotoField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new BookDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["bookInfo"] = this.bookInfo ? this.bookInfo.toJSON() : <any>undefined;
        data["lastSendTime"] = this.lastSendTime ? this.lastSendTime.toISOString() : <any>undefined;
        data["bookType"] = this.bookType;
        data["sequence"] = this.sequence;
        data["emailContent"] = this.emailContent;
        data["coverField"] = this.coverField ? this.coverField.toJSON() : <any>undefined;
        data["pdfField"] = this.pdfField ? this.pdfField.toJSON() : <any>undefined;
        if (this.emailField && this.emailField.constructor === Array) {
            data["emailField"] = [];
            for (let item of this.emailField)
                data["emailField"].push(item.toJSON());
        }
        return data; 
    }

    clone(): BookDto_Update {
        const json = this.toJSON();
        let result = new BookDto_Update();
        result.init(json);
        return result;
    }
}

export interface IBookDto_Update {
    id: number | undefined;
    title: string | undefined;
    bookInfo: BookInfoDto | undefined;
    lastSendTime: Date | undefined;
    bookType: BookDto_UpdateBookType | undefined;
    sequence: number | undefined;
    emailContent: string | undefined;
    coverField: PhotoField | undefined;
    pdfField: PdfField | undefined;
    emailField: PhotoField[] | undefined;
}

export class BookSubscriberDto_Create implements IBookSubscriberDto_Create {
    id: number | undefined;
    enable: boolean | undefined;
    email: string | undefined;
    unit: string | undefined;
    name: string | undefined;
    tel: string | undefined;

    constructor(data?: IBookSubscriberDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.enable = data["enable"];
            this.email = data["email"];
            this.unit = data["unit"];
            this.name = data["name"];
            this.tel = data["tel"];
        }
    }

    static fromJS(data: any): BookSubscriberDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new BookSubscriberDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enable"] = this.enable;
        data["email"] = this.email;
        data["unit"] = this.unit;
        data["name"] = this.name;
        data["tel"] = this.tel;
        return data; 
    }

    clone(): BookSubscriberDto_Create {
        const json = this.toJSON();
        let result = new BookSubscriberDto_Create();
        result.init(json);
        return result;
    }
}

export interface IBookSubscriberDto_Create {
    id: number | undefined;
    enable: boolean | undefined;
    email: string | undefined;
    unit: string | undefined;
    name: string | undefined;
    tel: string | undefined;
}

export class BookSubscriberDto_WithRelation implements IBookSubscriberDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    enable: boolean | undefined;
    email: string | undefined;
    unit: string | undefined;
    name: string | undefined;
    tel: string | undefined;

    constructor(data?: IBookSubscriberDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.id = data["id"];
            this.enable = data["enable"];
            this.email = data["email"];
            this.unit = data["unit"];
            this.name = data["name"];
            this.tel = data["tel"];
        }
    }

    static fromJS(data: any): BookSubscriberDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new BookSubscriberDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["enable"] = this.enable;
        data["email"] = this.email;
        data["unit"] = this.unit;
        data["name"] = this.name;
        data["tel"] = this.tel;
        return data; 
    }

    clone(): BookSubscriberDto_WithRelation {
        const json = this.toJSON();
        let result = new BookSubscriberDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IBookSubscriberDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    enable: boolean | undefined;
    email: string | undefined;
    unit: string | undefined;
    name: string | undefined;
    tel: string | undefined;
}

export class BookSubscriberDto_LoadAll implements IBookSubscriberDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IBookSubscriberDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): BookSubscriberDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new BookSubscriberDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): BookSubscriberDto_LoadAll {
        const json = this.toJSON();
        let result = new BookSubscriberDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IBookSubscriberDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfBookSubscriberDto_WithRelation implements IPagedResultDtoOfBookSubscriberDto_WithRelation {
    totalCount: number | undefined;
    items: BookSubscriberDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfBookSubscriberDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(BookSubscriberDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBookSubscriberDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBookSubscriberDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfBookSubscriberDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfBookSubscriberDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfBookSubscriberDto_WithRelation {
    totalCount: number | undefined;
    items: BookSubscriberDto_WithRelation[] | undefined;
}

export class BookSubscriberDto_Update implements IBookSubscriberDto_Update {
    id: number | undefined;
    enable: boolean | undefined;
    email: string | undefined;
    unit: string | undefined;
    name: string | undefined;
    tel: string | undefined;

    constructor(data?: IBookSubscriberDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.enable = data["enable"];
            this.email = data["email"];
            this.unit = data["unit"];
            this.name = data["name"];
            this.tel = data["tel"];
        }
    }

    static fromJS(data: any): BookSubscriberDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new BookSubscriberDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enable"] = this.enable;
        data["email"] = this.email;
        data["unit"] = this.unit;
        data["name"] = this.name;
        data["tel"] = this.tel;
        return data; 
    }

    clone(): BookSubscriberDto_Update {
        const json = this.toJSON();
        let result = new BookSubscriberDto_Update();
        result.init(json);
        return result;
    }
}

export interface IBookSubscriberDto_Update {
    id: number | undefined;
    enable: boolean | undefined;
    email: string | undefined;
    unit: string | undefined;
    name: string | undefined;
    tel: string | undefined;
}

export class EmailNotifyLoggerDto_LoadAll implements IEmailNotifyLoggerDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IEmailNotifyLoggerDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): EmailNotifyLoggerDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new EmailNotifyLoggerDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): EmailNotifyLoggerDto_LoadAll {
        const json = this.toJSON();
        let result = new EmailNotifyLoggerDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IEmailNotifyLoggerDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfEmailNotifyLoggerDto_WithRelation implements IPagedResultDtoOfEmailNotifyLoggerDto_WithRelation {
    totalCount: number | undefined;
    items: EmailNotifyLoggerDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfEmailNotifyLoggerDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(EmailNotifyLoggerDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEmailNotifyLoggerDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEmailNotifyLoggerDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfEmailNotifyLoggerDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfEmailNotifyLoggerDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfEmailNotifyLoggerDto_WithRelation {
    totalCount: number | undefined;
    items: EmailNotifyLoggerDto_WithRelation[] | undefined;
}

export class EmailNotifyLoggerDto_WithRelation implements IEmailNotifyLoggerDto_WithRelation {
    tenantId: number | undefined;
    id: number | undefined;
    isSend: boolean | undefined;
    sendTime: Date | undefined;
    message: string | undefined;
    toMail: string | undefined;
    createDateTime: Date | undefined;

    constructor(data?: IEmailNotifyLoggerDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.id = data["id"];
            this.isSend = data["isSend"];
            this.sendTime = data["sendTime"] ? new Date(data["sendTime"].toString()) : <any>undefined;
            this.message = data["message"];
            this.toMail = data["toMail"];
            this.createDateTime = data["createDateTime"] ? new Date(data["createDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailNotifyLoggerDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new EmailNotifyLoggerDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["isSend"] = this.isSend;
        data["sendTime"] = this.sendTime ? this.sendTime.toISOString() : <any>undefined;
        data["message"] = this.message;
        data["toMail"] = this.toMail;
        data["createDateTime"] = this.createDateTime ? this.createDateTime.toISOString() : <any>undefined;
        return data; 
    }

    clone(): EmailNotifyLoggerDto_WithRelation {
        const json = this.toJSON();
        let result = new EmailNotifyLoggerDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IEmailNotifyLoggerDto_WithRelation {
    tenantId: number | undefined;
    id: number | undefined;
    isSend: boolean | undefined;
    sendTime: Date | undefined;
    message: string | undefined;
    toMail: string | undefined;
    createDateTime: Date | undefined;
}

export class EmailNotifyLoggerDto_Create implements IEmailNotifyLoggerDto_Create {
    id: number | undefined;
    isSend: boolean | undefined;
    sendTime: Date | undefined;
    message: string | undefined;
    toMail: string | undefined;
    createDateTime: Date | undefined;

    constructor(data?: IEmailNotifyLoggerDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isSend = data["isSend"];
            this.sendTime = data["sendTime"] ? new Date(data["sendTime"].toString()) : <any>undefined;
            this.message = data["message"];
            this.toMail = data["toMail"];
            this.createDateTime = data["createDateTime"] ? new Date(data["createDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailNotifyLoggerDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new EmailNotifyLoggerDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSend"] = this.isSend;
        data["sendTime"] = this.sendTime ? this.sendTime.toISOString() : <any>undefined;
        data["message"] = this.message;
        data["toMail"] = this.toMail;
        data["createDateTime"] = this.createDateTime ? this.createDateTime.toISOString() : <any>undefined;
        return data; 
    }

    clone(): EmailNotifyLoggerDto_Create {
        const json = this.toJSON();
        let result = new EmailNotifyLoggerDto_Create();
        result.init(json);
        return result;
    }
}

export interface IEmailNotifyLoggerDto_Create {
    id: number | undefined;
    isSend: boolean | undefined;
    sendTime: Date | undefined;
    message: string | undefined;
    toMail: string | undefined;
    createDateTime: Date | undefined;
}

export class EmailNotifyLoggerDto_Update implements IEmailNotifyLoggerDto_Update {
    id: number | undefined;
    isSend: boolean | undefined;
    sendTime: Date | undefined;
    message: string | undefined;
    toMail: string | undefined;
    createDateTime: Date | undefined;

    constructor(data?: IEmailNotifyLoggerDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isSend = data["isSend"];
            this.sendTime = data["sendTime"] ? new Date(data["sendTime"].toString()) : <any>undefined;
            this.message = data["message"];
            this.toMail = data["toMail"];
            this.createDateTime = data["createDateTime"] ? new Date(data["createDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailNotifyLoggerDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new EmailNotifyLoggerDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSend"] = this.isSend;
        data["sendTime"] = this.sendTime ? this.sendTime.toISOString() : <any>undefined;
        data["message"] = this.message;
        data["toMail"] = this.toMail;
        data["createDateTime"] = this.createDateTime ? this.createDateTime.toISOString() : <any>undefined;
        return data; 
    }

    clone(): EmailNotifyLoggerDto_Update {
        const json = this.toJSON();
        let result = new EmailNotifyLoggerDto_Update();
        result.init(json);
        return result;
    }
}

export interface IEmailNotifyLoggerDto_Update {
    id: number | undefined;
    isSend: boolean | undefined;
    sendTime: Date | undefined;
    message: string | undefined;
    toMail: string | undefined;
    createDateTime: Date | undefined;
}

export class EmailSendingLogDto_LoadAll implements IEmailSendingLogDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IEmailSendingLogDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): EmailSendingLogDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSendingLogDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): EmailSendingLogDto_LoadAll {
        const json = this.toJSON();
        let result = new EmailSendingLogDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IEmailSendingLogDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfEmailSendingLogDto_WithRelation implements IPagedResultDtoOfEmailSendingLogDto_WithRelation {
    totalCount: number | undefined;
    items: EmailSendingLogDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfEmailSendingLogDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(EmailSendingLogDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEmailSendingLogDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEmailSendingLogDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfEmailSendingLogDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfEmailSendingLogDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfEmailSendingLogDto_WithRelation {
    totalCount: number | undefined;
    items: EmailSendingLogDto_WithRelation[] | undefined;
}

export class EmailSendingLogDto_WithRelation implements IEmailSendingLogDto_WithRelation {
    book: BookDto | undefined;
    bookSubscriber: BookSubscriberDto | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    isSend: boolean | undefined;
    sendTime: Date | undefined;
    bookId: number | undefined;
    bookSubscriberId: number | undefined;

    constructor(data?: IEmailSendingLogDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.book = data["book"] ? BookDto.fromJS(data["book"]) : <any>undefined;
            this.bookSubscriber = data["bookSubscriber"] ? BookSubscriberDto.fromJS(data["bookSubscriber"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.id = data["id"];
            this.isSend = data["isSend"];
            this.sendTime = data["sendTime"] ? new Date(data["sendTime"].toString()) : <any>undefined;
            this.bookId = data["bookId"];
            this.bookSubscriberId = data["bookSubscriberId"];
        }
    }

    static fromJS(data: any): EmailSendingLogDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSendingLogDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["book"] = this.book ? this.book.toJSON() : <any>undefined;
        data["bookSubscriber"] = this.bookSubscriber ? this.bookSubscriber.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["isSend"] = this.isSend;
        data["sendTime"] = this.sendTime ? this.sendTime.toISOString() : <any>undefined;
        data["bookId"] = this.bookId;
        data["bookSubscriberId"] = this.bookSubscriberId;
        return data; 
    }

    clone(): EmailSendingLogDto_WithRelation {
        const json = this.toJSON();
        let result = new EmailSendingLogDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IEmailSendingLogDto_WithRelation {
    book: BookDto | undefined;
    bookSubscriber: BookSubscriberDto | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    isSend: boolean | undefined;
    sendTime: Date | undefined;
    bookId: number | undefined;
    bookSubscriberId: number | undefined;
}

export class BookSubscriberDto implements IBookSubscriberDto {
    id: number | undefined;
    enable: boolean | undefined;
    email: string | undefined;
    unit: string | undefined;
    name: string | undefined;
    tel: string | undefined;

    constructor(data?: IBookSubscriberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.enable = data["enable"];
            this.email = data["email"];
            this.unit = data["unit"];
            this.name = data["name"];
            this.tel = data["tel"];
        }
    }

    static fromJS(data: any): BookSubscriberDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookSubscriberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enable"] = this.enable;
        data["email"] = this.email;
        data["unit"] = this.unit;
        data["name"] = this.name;
        data["tel"] = this.tel;
        return data; 
    }

    clone(): BookSubscriberDto {
        const json = this.toJSON();
        let result = new BookSubscriberDto();
        result.init(json);
        return result;
    }
}

export interface IBookSubscriberDto {
    id: number | undefined;
    enable: boolean | undefined;
    email: string | undefined;
    unit: string | undefined;
    name: string | undefined;
    tel: string | undefined;
}

export class EmailSendingLogDto_Create implements IEmailSendingLogDto_Create {
    id: number | undefined;
    isSend: boolean | undefined;
    sendTime: Date | undefined;
    bookId: number | undefined;
    bookSubscriberId: number | undefined;

    constructor(data?: IEmailSendingLogDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isSend = data["isSend"];
            this.sendTime = data["sendTime"] ? new Date(data["sendTime"].toString()) : <any>undefined;
            this.bookId = data["bookId"];
            this.bookSubscriberId = data["bookSubscriberId"];
        }
    }

    static fromJS(data: any): EmailSendingLogDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSendingLogDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSend"] = this.isSend;
        data["sendTime"] = this.sendTime ? this.sendTime.toISOString() : <any>undefined;
        data["bookId"] = this.bookId;
        data["bookSubscriberId"] = this.bookSubscriberId;
        return data; 
    }

    clone(): EmailSendingLogDto_Create {
        const json = this.toJSON();
        let result = new EmailSendingLogDto_Create();
        result.init(json);
        return result;
    }
}

export interface IEmailSendingLogDto_Create {
    id: number | undefined;
    isSend: boolean | undefined;
    sendTime: Date | undefined;
    bookId: number | undefined;
    bookSubscriberId: number | undefined;
}

export class EmailSendingLogDto_Update implements IEmailSendingLogDto_Update {
    id: number | undefined;
    isSend: boolean | undefined;
    sendTime: Date | undefined;
    bookId: number | undefined;
    bookSubscriberId: number | undefined;

    constructor(data?: IEmailSendingLogDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isSend = data["isSend"];
            this.sendTime = data["sendTime"] ? new Date(data["sendTime"].toString()) : <any>undefined;
            this.bookId = data["bookId"];
            this.bookSubscriberId = data["bookSubscriberId"];
        }
    }

    static fromJS(data: any): EmailSendingLogDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSendingLogDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSend"] = this.isSend;
        data["sendTime"] = this.sendTime ? this.sendTime.toISOString() : <any>undefined;
        data["bookId"] = this.bookId;
        data["bookSubscriberId"] = this.bookSubscriberId;
        return data; 
    }

    clone(): EmailSendingLogDto_Update {
        const json = this.toJSON();
        let result = new EmailSendingLogDto_Update();
        result.init(json);
        return result;
    }
}

export interface IEmailSendingLogDto_Update {
    id: number | undefined;
    isSend: boolean | undefined;
    sendTime: Date | undefined;
    bookId: number | undefined;
    bookSubscriberId: number | undefined;
}

export class ImportFormErrorLogDto implements IImportFormErrorLogDto {
    fileName: string | undefined;
    importSheets: ImportSheetDto[] | undefined;

    constructor(data?: IImportFormErrorLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            if (data["importSheets"] && data["importSheets"].constructor === Array) {
                this.importSheets = [] as any;
                for (let item of data["importSheets"])
                    this.importSheets.push(ImportSheetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportFormErrorLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFormErrorLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        if (this.importSheets && this.importSheets.constructor === Array) {
            data["importSheets"] = [];
            for (let item of this.importSheets)
                data["importSheets"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ImportFormErrorLogDto {
        const json = this.toJSON();
        let result = new ImportFormErrorLogDto();
        result.init(json);
        return result;
    }
}

export interface IImportFormErrorLogDto {
    fileName: string | undefined;
    importSheets: ImportSheetDto[] | undefined;
}

export class ImportSheetDto implements IImportSheetDto {
    sheetName: string | undefined;
    errorMessage: string | undefined;
    rowErrors: RowError[] | undefined;

    constructor(data?: IImportSheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sheetName = data["sheetName"];
            this.errorMessage = data["errorMessage"];
            if (data["rowErrors"] && data["rowErrors"].constructor === Array) {
                this.rowErrors = [] as any;
                for (let item of data["rowErrors"])
                    this.rowErrors.push(RowError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportSheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportSheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sheetName"] = this.sheetName;
        data["errorMessage"] = this.errorMessage;
        if (this.rowErrors && this.rowErrors.constructor === Array) {
            data["rowErrors"] = [];
            for (let item of this.rowErrors)
                data["rowErrors"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ImportSheetDto {
        const json = this.toJSON();
        let result = new ImportSheetDto();
        result.init(json);
        return result;
    }
}

export interface IImportSheetDto {
    sheetName: string | undefined;
    errorMessage: string | undefined;
    rowErrors: RowError[] | undefined;
}

export class RowError implements IRowError {
    row: number | undefined;
    errorMessage: string | undefined;

    constructor(data?: IRowError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.row = data["row"];
            this.errorMessage = data["errorMessage"];
        }
    }

    static fromJS(data: any): RowError {
        data = typeof data === 'object' ? data : {};
        let result = new RowError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["row"] = this.row;
        data["errorMessage"] = this.errorMessage;
        return data; 
    }

    clone(): RowError {
        const json = this.toJSON();
        let result = new RowError();
        result.init(json);
        return result;
    }
}

export interface IRowError {
    row: number | undefined;
    errorMessage: string | undefined;
}

export class MailMessageDto implements IMailMessageDto {
    emails: string[] | undefined;
    message: string | undefined;

    constructor(data?: IMailMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["emails"] && data["emails"].constructor === Array) {
                this.emails = [] as any;
                for (let item of data["emails"])
                    this.emails.push(item);
            }
            this.message = data["message"];
        }
    }

    static fromJS(data: any): MailMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.emails && this.emails.constructor === Array) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["message"] = this.message;
        return data; 
    }

    clone(): MailMessageDto {
        const json = this.toJSON();
        let result = new MailMessageDto();
        result.init(json);
        return result;
    }
}

export interface IMailMessageDto {
    emails: string[] | undefined;
    message: string | undefined;
}

export class RecordTimeStampDto_LoadAll implements IRecordTimeStampDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IRecordTimeStampDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): RecordTimeStampDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new RecordTimeStampDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): RecordTimeStampDto_LoadAll {
        const json = this.toJSON();
        let result = new RecordTimeStampDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IRecordTimeStampDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfRecordTimeStampDto_WithRelation implements IPagedResultDtoOfRecordTimeStampDto_WithRelation {
    totalCount: number | undefined;
    items: RecordTimeStampDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfRecordTimeStampDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(RecordTimeStampDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRecordTimeStampDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRecordTimeStampDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfRecordTimeStampDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfRecordTimeStampDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfRecordTimeStampDto_WithRelation {
    totalCount: number | undefined;
    items: RecordTimeStampDto_WithRelation[] | undefined;
}

export class RecordTimeStampDto_WithRelation implements IRecordTimeStampDto_WithRelation {
    tenantId: number | undefined;
    id: number | undefined;
    name: string | undefined;
    value: string | undefined;
    recordType: RecordTimeStampDto_WithRelationRecordType | undefined;

    constructor(data?: IRecordTimeStampDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.id = data["id"];
            this.name = data["name"];
            this.value = data["value"];
            this.recordType = data["recordType"];
        }
    }

    static fromJS(data: any): RecordTimeStampDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new RecordTimeStampDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["recordType"] = this.recordType;
        return data; 
    }

    clone(): RecordTimeStampDto_WithRelation {
        const json = this.toJSON();
        let result = new RecordTimeStampDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IRecordTimeStampDto_WithRelation {
    tenantId: number | undefined;
    id: number | undefined;
    name: string | undefined;
    value: string | undefined;
    recordType: RecordTimeStampDto_WithRelationRecordType | undefined;
}

export class RecordTimeStampDto_Create implements IRecordTimeStampDto_Create {
    id: number | undefined;
    name: string | undefined;
    value: string | undefined;
    recordType: RecordTimeStampDto_CreateRecordType | undefined;

    constructor(data?: IRecordTimeStampDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.value = data["value"];
            this.recordType = data["recordType"];
        }
    }

    static fromJS(data: any): RecordTimeStampDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new RecordTimeStampDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["recordType"] = this.recordType;
        return data; 
    }

    clone(): RecordTimeStampDto_Create {
        const json = this.toJSON();
        let result = new RecordTimeStampDto_Create();
        result.init(json);
        return result;
    }
}

export interface IRecordTimeStampDto_Create {
    id: number | undefined;
    name: string | undefined;
    value: string | undefined;
    recordType: RecordTimeStampDto_CreateRecordType | undefined;
}

export class RecordTimeStampDto_Update implements IRecordTimeStampDto_Update {
    id: number | undefined;
    name: string | undefined;
    value: string | undefined;
    recordType: RecordTimeStampDto_UpdateRecordType | undefined;

    constructor(data?: IRecordTimeStampDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.value = data["value"];
            this.recordType = data["recordType"];
        }
    }

    static fromJS(data: any): RecordTimeStampDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new RecordTimeStampDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["recordType"] = this.recordType;
        return data; 
    }

    clone(): RecordTimeStampDto_Update {
        const json = this.toJSON();
        let result = new RecordTimeStampDto_Update();
        result.init(json);
        return result;
    }
}

export interface IRecordTimeStampDto_Update {
    id: number | undefined;
    name: string | undefined;
    value: string | undefined;
    recordType: RecordTimeStampDto_UpdateRecordType | undefined;
}

export class RegulationDto_Create implements IRegulationDto_Create {
    id: number | undefined;
    name: string | undefined;
    unit: string | undefined;
    rank: number | undefined;
    parentId: number | undefined;
    seaReaType: SeaAreaTypeDto | undefined;

    constructor(data?: IRegulationDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.unit = data["unit"];
            this.rank = data["rank"];
            this.parentId = data["parentId"];
            this.seaReaType = data["seaReaType"] ? SeaAreaTypeDto.fromJS(data["seaReaType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegulationDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new RegulationDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["rank"] = this.rank;
        data["parentId"] = this.parentId;
        data["seaReaType"] = this.seaReaType ? this.seaReaType.toJSON() : <any>undefined;
        return data; 
    }

    clone(): RegulationDto_Create {
        const json = this.toJSON();
        let result = new RegulationDto_Create();
        result.init(json);
        return result;
    }
}

export interface IRegulationDto_Create {
    id: number | undefined;
    name: string | undefined;
    unit: string | undefined;
    rank: number | undefined;
    parentId: number | undefined;
    seaReaType: SeaAreaTypeDto | undefined;
}

export class SeaAreaTypeDto implements ISeaAreaTypeDto {
    甲類海域: string | undefined;
    乙類海域: string | undefined;
    丙類海域: string | undefined;

    constructor(data?: ISeaAreaTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.甲類海域 = data["甲類海域"];
            this.乙類海域 = data["乙類海域"];
            this.丙類海域 = data["丙類海域"];
        }
    }

    static fromJS(data: any): SeaAreaTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeaAreaTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["甲類海域"] = this.甲類海域;
        data["乙類海域"] = this.乙類海域;
        data["丙類海域"] = this.丙類海域;
        return data; 
    }

    clone(): SeaAreaTypeDto {
        const json = this.toJSON();
        let result = new SeaAreaTypeDto();
        result.init(json);
        return result;
    }
}

export interface ISeaAreaTypeDto {
    甲類海域: string | undefined;
    乙類海域: string | undefined;
    丙類海域: string | undefined;
}

export class RegulationDto_WithRelation implements IRegulationDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    name: string | undefined;
    unit: string | undefined;
    rank: number | undefined;
    parentId: number | undefined;
    seaReaType: SeaAreaTypeDto | undefined;

    constructor(data?: IRegulationDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.id = data["id"];
            this.name = data["name"];
            this.unit = data["unit"];
            this.rank = data["rank"];
            this.parentId = data["parentId"];
            this.seaReaType = data["seaReaType"] ? SeaAreaTypeDto.fromJS(data["seaReaType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegulationDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new RegulationDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["rank"] = this.rank;
        data["parentId"] = this.parentId;
        data["seaReaType"] = this.seaReaType ? this.seaReaType.toJSON() : <any>undefined;
        return data; 
    }

    clone(): RegulationDto_WithRelation {
        const json = this.toJSON();
        let result = new RegulationDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IRegulationDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    name: string | undefined;
    unit: string | undefined;
    rank: number | undefined;
    parentId: number | undefined;
    seaReaType: SeaAreaTypeDto | undefined;
}

export class RegulationDto_Update implements IRegulationDto_Update {
    id: number | undefined;
    name: string | undefined;
    unit: string | undefined;
    rank: number | undefined;
    parentId: number | undefined;
    seaReaType: SeaAreaTypeDto | undefined;

    constructor(data?: IRegulationDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.unit = data["unit"];
            this.rank = data["rank"];
            this.parentId = data["parentId"];
            this.seaReaType = data["seaReaType"] ? SeaAreaTypeDto.fromJS(data["seaReaType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegulationDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new RegulationDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["rank"] = this.rank;
        data["parentId"] = this.parentId;
        data["seaReaType"] = this.seaReaType ? this.seaReaType.toJSON() : <any>undefined;
        return data; 
    }

    clone(): RegulationDto_Update {
        const json = this.toJSON();
        let result = new RegulationDto_Update();
        result.init(json);
        return result;
    }
}

export interface IRegulationDto_Update {
    id: number | undefined;
    name: string | undefined;
    unit: string | undefined;
    rank: number | undefined;
    parentId: number | undefined;
    seaReaType: SeaAreaTypeDto | undefined;
}

export class RegulationDto implements IRegulationDto {
    id: number | undefined;
    name: string | undefined;
    unit: string | undefined;
    rank: number | undefined;
    parentId: number | undefined;
    seaReaType: SeaAreaTypeDto | undefined;

    constructor(data?: IRegulationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.unit = data["unit"];
            this.rank = data["rank"];
            this.parentId = data["parentId"];
            this.seaReaType = data["seaReaType"] ? SeaAreaTypeDto.fromJS(data["seaReaType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegulationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegulationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["rank"] = this.rank;
        data["parentId"] = this.parentId;
        data["seaReaType"] = this.seaReaType ? this.seaReaType.toJSON() : <any>undefined;
        return data; 
    }

    clone(): RegulationDto {
        const json = this.toJSON();
        let result = new RegulationDto();
        result.init(json);
        return result;
    }
}

export interface IRegulationDto {
    id: number | undefined;
    name: string | undefined;
    unit: string | undefined;
    rank: number | undefined;
    parentId: number | undefined;
    seaReaType: SeaAreaTypeDto | undefined;
}

export class RegulationDto_LoadAll implements IRegulationDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IRegulationDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): RegulationDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new RegulationDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): RegulationDto_LoadAll {
        const json = this.toJSON();
        let result = new RegulationDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IRegulationDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfRegulationDto_WithRelation implements IPagedResultDtoOfRegulationDto_WithRelation {
    totalCount: number | undefined;
    items: RegulationDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfRegulationDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(RegulationDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRegulationDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRegulationDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfRegulationDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfRegulationDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfRegulationDto_WithRelation {
    totalCount: number | undefined;
    items: RegulationDto_WithRelation[] | undefined;
}

export class SettingDto implements ISettingDto {
    visitorCount: number | undefined;
    webPhone: string | undefined;
    webEmail: string | undefined;
    webName: string | undefined;
    webDescription: string | undefined;
    dailyMailMaxSendCount: number | undefined;
    recordTimeStamp: DateTimeValueDto[] | undefined;

    constructor(data?: ISettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.visitorCount = data["visitorCount"];
            this.webPhone = data["webPhone"];
            this.webEmail = data["webEmail"];
            this.webName = data["webName"];
            this.webDescription = data["webDescription"];
            this.dailyMailMaxSendCount = data["dailyMailMaxSendCount"];
            if (data["recordTimeStamp"] && data["recordTimeStamp"].constructor === Array) {
                this.recordTimeStamp = [] as any;
                for (let item of data["recordTimeStamp"])
                    this.recordTimeStamp.push(DateTimeValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitorCount"] = this.visitorCount;
        data["webPhone"] = this.webPhone;
        data["webEmail"] = this.webEmail;
        data["webName"] = this.webName;
        data["webDescription"] = this.webDescription;
        data["dailyMailMaxSendCount"] = this.dailyMailMaxSendCount;
        if (this.recordTimeStamp && this.recordTimeStamp.constructor === Array) {
            data["recordTimeStamp"] = [];
            for (let item of this.recordTimeStamp)
                data["recordTimeStamp"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SettingDto {
        const json = this.toJSON();
        let result = new SettingDto();
        result.init(json);
        return result;
    }
}

export interface ISettingDto {
    visitorCount: number | undefined;
    webPhone: string | undefined;
    webEmail: string | undefined;
    webName: string | undefined;
    webDescription: string | undefined;
    dailyMailMaxSendCount: number | undefined;
    recordTimeStamp: DateTimeValueDto[] | undefined;
}

export class DateTimeValueDto implements IDateTimeValueDto {
    sequence: number | undefined;
    target: string | undefined;
    value: string | undefined;

    constructor(data?: IDateTimeValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sequence = data["sequence"];
            this.target = data["target"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): DateTimeValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequence"] = this.sequence;
        data["target"] = this.target;
        data["value"] = this.value;
        return data; 
    }

    clone(): DateTimeValueDto {
        const json = this.toJSON();
        let result = new DateTimeValueDto();
        result.init(json);
        return result;
    }
}

export interface IDateTimeValueDto {
    sequence: number | undefined;
    target: string | undefined;
    value: string | undefined;
}

export class FormStationRecordDto implements IFormStationRecordDto {
    id: number | undefined;
    recordStatus: FormStationRecordDtoRecordStatus | undefined;
    submitDate: Date | undefined;
    docmentlId: number | undefined;
    recorder: string | undefined;
    recordData: RecordData[] | undefined;
    stationRecord: StationDetailDto | undefined;

    constructor(data?: IFormStationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.recordStatus = data["recordStatus"];
            this.submitDate = data["submitDate"] ? new Date(data["submitDate"].toString()) : <any>undefined;
            this.docmentlId = data["docmentlId"];
            this.recorder = data["recorder"];
            if (data["recordData"] && data["recordData"].constructor === Array) {
                this.recordData = [] as any;
                for (let item of data["recordData"])
                    this.recordData.push(RecordData.fromJS(item));
            }
            this.stationRecord = data["stationRecord"] ? StationDetailDto.fromJS(data["stationRecord"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FormStationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormStationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recordStatus"] = this.recordStatus;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["docmentlId"] = this.docmentlId;
        data["recorder"] = this.recorder;
        if (this.recordData && this.recordData.constructor === Array) {
            data["recordData"] = [];
            for (let item of this.recordData)
                data["recordData"].push(item.toJSON());
        }
        data["stationRecord"] = this.stationRecord ? this.stationRecord.toJSON() : <any>undefined;
        return data; 
    }

    clone(): FormStationRecordDto {
        const json = this.toJSON();
        let result = new FormStationRecordDto();
        result.init(json);
        return result;
    }
}

export interface IFormStationRecordDto {
    id: number | undefined;
    recordStatus: FormStationRecordDtoRecordStatus | undefined;
    submitDate: Date | undefined;
    docmentlId: number | undefined;
    recorder: string | undefined;
    recordData: RecordData[] | undefined;
    stationRecord: StationDetailDto | undefined;
}

export class RecordData implements IRecordData {
    items: QuestItem[] | undefined;
    groupId: number | undefined;

    constructor(data?: IRecordData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(QuestItem.fromJS(item));
            }
            this.groupId = data["groupId"];
        }
    }

    static fromJS(data: any): RecordData {
        data = typeof data === 'object' ? data : {};
        let result = new RecordData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["groupId"] = this.groupId;
        return data; 
    }

    clone(): RecordData {
        const json = this.toJSON();
        let result = new RecordData();
        result.init(json);
        return result;
    }
}

export interface IRecordData {
    items: QuestItem[] | undefined;
    groupId: number | undefined;
}

export class StationDetailDto implements IStationDetailDto {
    id: number | undefined;
    monitorDate: Date | undefined;
    monitorStringDate: string | undefined;
    stationId: number | undefined;
    station: StationDto | undefined;

    constructor(data?: IStationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.monitorDate = data["monitorDate"] ? new Date(data["monitorDate"].toString()) : <any>undefined;
            this.monitorStringDate = data["monitorStringDate"];
            this.stationId = data["stationId"];
            this.station = data["station"] ? StationDto.fromJS(data["station"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new StationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["monitorDate"] = this.monitorDate ? this.monitorDate.toISOString() : <any>undefined;
        data["monitorStringDate"] = this.monitorStringDate;
        data["stationId"] = this.stationId;
        data["station"] = this.station ? this.station.toJSON() : <any>undefined;
        return data; 
    }

    clone(): StationDetailDto {
        const json = this.toJSON();
        let result = new StationDetailDto();
        result.init(json);
        return result;
    }
}

export interface IStationDetailDto {
    id: number | undefined;
    monitorDate: Date | undefined;
    monitorStringDate: string | undefined;
    stationId: number | undefined;
    station: StationDto | undefined;
}

export class QuestItem implements IQuestItem {
    questNumber: number | undefined;
    answer: string | undefined;

    constructor(data?: IQuestItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questNumber = data["questNumber"];
            this.answer = data["answer"];
        }
    }

    static fromJS(data: any): QuestItem {
        data = typeof data === 'object' ? data : {};
        let result = new QuestItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questNumber"] = this.questNumber;
        data["answer"] = this.answer;
        return data; 
    }

    clone(): QuestItem {
        const json = this.toJSON();
        let result = new QuestItem();
        result.init(json);
        return result;
    }
}

export interface IQuestItem {
    questNumber: number | undefined;
    answer: string | undefined;
}

export class StationDto implements IStationDto {
    id: number | undefined;
    name: string | undefined;
    no: number | undefined;
    country: string | undefined;
    lat: string | undefined;
    lng: string | undefined;
    waterType: string | undefined;
    location: string | undefined;

    constructor(data?: IStationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.no = data["no"];
            this.country = data["country"];
            this.lat = data["lat"];
            this.lng = data["lng"];
            this.waterType = data["waterType"];
            this.location = data["location"];
        }
    }

    static fromJS(data: any): StationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["no"] = this.no;
        data["country"] = this.country;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["waterType"] = this.waterType;
        data["location"] = this.location;
        return data; 
    }

    clone(): StationDto {
        const json = this.toJSON();
        let result = new StationDto();
        result.init(json);
        return result;
    }
}

export interface IStationDto {
    id: number | undefined;
    name: string | undefined;
    no: number | undefined;
    country: string | undefined;
    lat: string | undefined;
    lng: string | undefined;
    waterType: string | undefined;
    location: string | undefined;
}

export class MultipleDocRecordDto implements IMultipleDocRecordDto {
    record: DateKeyDto[] | undefined;
    docId: number | undefined;
    no: string | undefined;
    name: string | undefined;
    formal: FormFormal | undefined;
    year: string | undefined;
    month: string | undefined;
    version: string | undefined;

    constructor(data?: IMultipleDocRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["record"] && data["record"].constructor === Array) {
                this.record = [] as any;
                for (let item of data["record"])
                    this.record.push(DateKeyDto.fromJS(item));
            }
            this.docId = data["docId"];
            this.no = data["no"];
            this.name = data["name"];
            this.formal = data["formal"] ? FormFormal.fromJS(data["formal"]) : <any>undefined;
            this.year = data["year"];
            this.month = data["month"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): MultipleDocRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleDocRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.record && this.record.constructor === Array) {
            data["record"] = [];
            for (let item of this.record)
                data["record"].push(item.toJSON());
        }
        data["docId"] = this.docId;
        data["no"] = this.no;
        data["name"] = this.name;
        data["formal"] = this.formal ? this.formal.toJSON() : <any>undefined;
        data["year"] = this.year;
        data["month"] = this.month;
        data["version"] = this.version;
        return data; 
    }

    clone(): MultipleDocRecordDto {
        const json = this.toJSON();
        let result = new MultipleDocRecordDto();
        result.init(json);
        return result;
    }
}

export interface IMultipleDocRecordDto {
    record: DateKeyDto[] | undefined;
    docId: number | undefined;
    no: string | undefined;
    name: string | undefined;
    formal: FormFormal | undefined;
    year: string | undefined;
    month: string | undefined;
    version: string | undefined;
}

export class DateKeyDto implements IDateKeyDto {
    key: string | undefined;
    year: string | undefined;
    month: string | undefined;
    datas: FormStationRecordDto[] | undefined;

    constructor(data?: IDateKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.year = data["year"];
            this.month = data["month"];
            if (data["datas"] && data["datas"].constructor === Array) {
                this.datas = [] as any;
                for (let item of data["datas"])
                    this.datas.push(FormStationRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DateKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["year"] = this.year;
        data["month"] = this.month;
        if (this.datas && this.datas.constructor === Array) {
            data["datas"] = [];
            for (let item of this.datas)
                data["datas"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DateKeyDto {
        const json = this.toJSON();
        let result = new DateKeyDto();
        result.init(json);
        return result;
    }
}

export interface IDateKeyDto {
    key: string | undefined;
    year: string | undefined;
    month: string | undefined;
    datas: FormStationRecordDto[] | undefined;
}

export class FormFormal implements IFormFormal {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;
    id: number | undefined;
    no: string | undefined;
    name: string | undefined;
    sequence: number | undefined;
    tenantId: number | undefined;
    fullAudited: FullAudited | undefined;
    frequence: FormFormalFrequence | undefined;
    formGroups: FormGroup[] | undefined;

    constructor(data?: IFormFormal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.id = data["id"];
            this.no = data["no"];
            this.name = data["name"];
            this.sequence = data["sequence"];
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAudited.fromJS(data["fullAudited"]) : <any>undefined;
            this.frequence = data["frequence"];
            if (data["formGroups"] && data["formGroups"].constructor === Array) {
                this.formGroups = [] as any;
                for (let item of data["formGroups"])
                    this.formGroups.push(FormGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormFormal {
        data = typeof data === 'object' ? data : {};
        let result = new FormFormal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        data["no"] = this.no;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["frequence"] = this.frequence;
        if (this.formGroups && this.formGroups.constructor === Array) {
            data["formGroups"] = [];
            for (let item of this.formGroups)
                data["formGroups"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FormFormal {
        const json = this.toJSON();
        let result = new FormFormal();
        result.init(json);
        return result;
    }
}

export interface IFormFormal {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;
    id: number | undefined;
    no: string | undefined;
    name: string | undefined;
    sequence: number | undefined;
    tenantId: number | undefined;
    fullAudited: FullAudited | undefined;
    frequence: FormFormalFrequence | undefined;
    formGroups: FormGroup[] | undefined;
}

export class FullAudited implements IFullAudited {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;

    constructor(data?: IFullAudited) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
        }
    }

    static fromJS(data: any): FullAudited {
        data = typeof data === 'object' ? data : {};
        let result = new FullAudited();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data; 
    }

    clone(): FullAudited {
        const json = this.toJSON();
        let result = new FullAudited();
        result.init(json);
        return result;
    }
}

export interface IFullAudited {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;
}

export class FormGroup implements IFormGroup {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;
    formItems: FormItem[] | undefined;
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;
    extensionData: string | undefined;
    tenantId: number | undefined;
    fullAudited: FullAudited | undefined;
    formFormalId: number | undefined;
    formFormal: FormFormal | undefined;

    constructor(data?: IFormGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            if (data["formItems"] && data["formItems"].constructor === Array) {
                this.formItems = [] as any;
                for (let item of data["formItems"])
                    this.formItems.push(FormItem.fromJS(item));
            }
            this.id = data["id"];
            this.name = data["name"];
            this.sequence = data["sequence"];
            this.extensionData = data["extensionData"];
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAudited.fromJS(data["fullAudited"]) : <any>undefined;
            this.formFormalId = data["formFormalId"];
            this.formFormal = data["formFormal"] ? FormFormal.fromJS(data["formFormal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FormGroup {
        data = typeof data === 'object' ? data : {};
        let result = new FormGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        if (this.formItems && this.formItems.constructor === Array) {
            data["formItems"] = [];
            for (let item of this.formItems)
                data["formItems"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["extensionData"] = this.extensionData;
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["formFormalId"] = this.formFormalId;
        data["formFormal"] = this.formFormal ? this.formFormal.toJSON() : <any>undefined;
        return data; 
    }

    clone(): FormGroup {
        const json = this.toJSON();
        let result = new FormGroup();
        result.init(json);
        return result;
    }
}

export interface IFormGroup {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;
    formItems: FormItem[] | undefined;
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;
    extensionData: string | undefined;
    tenantId: number | undefined;
    fullAudited: FullAudited | undefined;
    formFormalId: number | undefined;
    formFormal: FormFormal | undefined;
}

export class FormItem implements IFormItem {
    question: string | undefined;
    answer: string | undefined;
    sequence: string | undefined;
    type: FormItemType | undefined;
    option: string | undefined;
    isRequired: boolean | undefined;

    constructor(data?: IFormItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.question = data["question"];
            this.answer = data["answer"];
            this.sequence = data["sequence"];
            this.type = data["type"];
            this.option = data["option"];
            this.isRequired = data["isRequired"];
        }
    }

    static fromJS(data: any): FormItem {
        data = typeof data === 'object' ? data : {};
        let result = new FormItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["answer"] = this.answer;
        data["sequence"] = this.sequence;
        data["type"] = this.type;
        data["option"] = this.option;
        data["isRequired"] = this.isRequired;
        return data; 
    }

    clone(): FormItem {
        const json = this.toJSON();
        let result = new FormItem();
        result.init(json);
        return result;
    }
}

export interface IFormItem {
    question: string | undefined;
    answer: string | undefined;
    sequence: string | undefined;
    type: FormItemType | undefined;
    option: string | undefined;
    isRequired: boolean | undefined;
}

export class SearchStationDto implements ISearchStationDto {
    no: number | undefined;
    country: string | undefined;
    location: string | undefined;
    keyword: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: ISearchStationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.no = data["no"];
            this.country = data["country"];
            this.location = data["location"];
            this.keyword = data["keyword"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): SearchStationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchStationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["no"] = this.no;
        data["country"] = this.country;
        data["location"] = this.location;
        data["keyword"] = this.keyword;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): SearchStationDto {
        const json = this.toJSON();
        let result = new SearchStationDto();
        result.init(json);
        return result;
    }
}

export interface ISearchStationDto {
    no: number | undefined;
    country: string | undefined;
    location: string | undefined;
    keyword: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfStationDto_WithRelation implements IPagedResultDtoOfStationDto_WithRelation {
    totalCount: number | undefined;
    items: StationDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfStationDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(StationDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStationDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStationDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfStationDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfStationDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfStationDto_WithRelation {
    totalCount: number | undefined;
    items: StationDto_WithRelation[] | undefined;
}

export class StationDto_WithRelation implements IStationDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    name: string | undefined;
    no: number | undefined;
    country: string | undefined;
    lat: string | undefined;
    lng: string | undefined;
    waterType: string | undefined;
    location: string | undefined;

    constructor(data?: IStationDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.id = data["id"];
            this.name = data["name"];
            this.no = data["no"];
            this.country = data["country"];
            this.lat = data["lat"];
            this.lng = data["lng"];
            this.waterType = data["waterType"];
            this.location = data["location"];
        }
    }

    static fromJS(data: any): StationDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new StationDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["no"] = this.no;
        data["country"] = this.country;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["waterType"] = this.waterType;
        data["location"] = this.location;
        return data; 
    }

    clone(): StationDto_WithRelation {
        const json = this.toJSON();
        let result = new StationDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IStationDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    name: string | undefined;
    no: number | undefined;
    country: string | undefined;
    lat: string | undefined;
    lng: string | undefined;
    waterType: string | undefined;
    location: string | undefined;
}

export class StationDto_LoadAll implements IStationDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IStationDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): StationDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new StationDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): StationDto_LoadAll {
        const json = this.toJSON();
        let result = new StationDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IStationDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class StationDto_Create implements IStationDto_Create {
    id: number | undefined;
    name: string | undefined;
    no: number | undefined;
    country: string | undefined;
    lat: string | undefined;
    lng: string | undefined;
    waterType: string | undefined;
    location: string | undefined;

    constructor(data?: IStationDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.no = data["no"];
            this.country = data["country"];
            this.lat = data["lat"];
            this.lng = data["lng"];
            this.waterType = data["waterType"];
            this.location = data["location"];
        }
    }

    static fromJS(data: any): StationDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new StationDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["no"] = this.no;
        data["country"] = this.country;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["waterType"] = this.waterType;
        data["location"] = this.location;
        return data; 
    }

    clone(): StationDto_Create {
        const json = this.toJSON();
        let result = new StationDto_Create();
        result.init(json);
        return result;
    }
}

export interface IStationDto_Create {
    id: number | undefined;
    name: string | undefined;
    no: number | undefined;
    country: string | undefined;
    lat: string | undefined;
    lng: string | undefined;
    waterType: string | undefined;
    location: string | undefined;
}

export class StationDto_Update implements IStationDto_Update {
    id: number | undefined;
    name: string | undefined;
    no: number | undefined;
    country: string | undefined;
    lat: string | undefined;
    lng: string | undefined;
    waterType: string | undefined;
    location: string | undefined;

    constructor(data?: IStationDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.no = data["no"];
            this.country = data["country"];
            this.lat = data["lat"];
            this.lng = data["lng"];
            this.waterType = data["waterType"];
            this.location = data["location"];
        }
    }

    static fromJS(data: any): StationDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new StationDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["no"] = this.no;
        data["country"] = this.country;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["waterType"] = this.waterType;
        data["location"] = this.location;
        return data; 
    }

    clone(): StationDto_Update {
        const json = this.toJSON();
        let result = new StationDto_Update();
        result.init(json);
        return result;
    }
}

export interface IStationDto_Update {
    id: number | undefined;
    name: string | undefined;
    no: number | undefined;
    country: string | undefined;
    lat: string | undefined;
    lng: string | undefined;
    waterType: string | undefined;
    location: string | undefined;
}

export class StationRecordDto implements IStationRecordDto {
    id: number | undefined;
    monitorDate: Date | undefined;
    stationId: number | undefined;
    recordId: number | undefined;
    remark: string | undefined;

    constructor(data?: IStationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.monitorDate = data["monitorDate"] ? new Date(data["monitorDate"].toString()) : <any>undefined;
            this.stationId = data["stationId"];
            this.recordId = data["recordId"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): StationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new StationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["monitorDate"] = this.monitorDate ? this.monitorDate.toISOString() : <any>undefined;
        data["stationId"] = this.stationId;
        data["recordId"] = this.recordId;
        data["remark"] = this.remark;
        return data; 
    }

    clone(): StationRecordDto {
        const json = this.toJSON();
        let result = new StationRecordDto();
        result.init(json);
        return result;
    }
}

export interface IStationRecordDto {
    id: number | undefined;
    monitorDate: Date | undefined;
    stationId: number | undefined;
    recordId: number | undefined;
    remark: string | undefined;
}

export class StationRecordDto_LoadAll implements IStationRecordDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IStationRecordDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): StationRecordDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new StationRecordDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): StationRecordDto_LoadAll {
        const json = this.toJSON();
        let result = new StationRecordDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IStationRecordDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfStationWithRecordDto implements IPagedResultDtoOfStationWithRecordDto {
    totalCount: number | undefined;
    items: StationWithRecordDto[] | undefined;

    constructor(data?: IPagedResultDtoOfStationWithRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(StationWithRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStationWithRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStationWithRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfStationWithRecordDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfStationWithRecordDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfStationWithRecordDto {
    totalCount: number | undefined;
    items: StationWithRecordDto[] | undefined;
}

export class StationWithRecordDto implements IStationWithRecordDto {
    stationRecord: StationRecordDto | undefined;

    constructor(data?: IStationWithRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stationRecord = data["stationRecord"] ? StationRecordDto.fromJS(data["stationRecord"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StationWithRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new StationWithRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stationRecord"] = this.stationRecord ? this.stationRecord.toJSON() : <any>undefined;
        return data; 
    }

    clone(): StationWithRecordDto {
        const json = this.toJSON();
        let result = new StationWithRecordDto();
        result.init(json);
        return result;
    }
}

export interface IStationWithRecordDto {
    stationRecord: StationRecordDto | undefined;
}

export class PagedResultDtoOfStationRecordDto_WithRelation implements IPagedResultDtoOfStationRecordDto_WithRelation {
    totalCount: number | undefined;
    items: StationRecordDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfStationRecordDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(StationRecordDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStationRecordDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStationRecordDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfStationRecordDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfStationRecordDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfStationRecordDto_WithRelation {
    totalCount: number | undefined;
    items: StationRecordDto_WithRelation[] | undefined;
}

export class StationRecordDto_WithRelation implements IStationRecordDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    monitorDate: Date | undefined;
    stationId: number | undefined;
    recordId: number | undefined;
    remark: string | undefined;

    constructor(data?: IStationRecordDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.id = data["id"];
            this.monitorDate = data["monitorDate"] ? new Date(data["monitorDate"].toString()) : <any>undefined;
            this.stationId = data["stationId"];
            this.recordId = data["recordId"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): StationRecordDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new StationRecordDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["monitorDate"] = this.monitorDate ? this.monitorDate.toISOString() : <any>undefined;
        data["stationId"] = this.stationId;
        data["recordId"] = this.recordId;
        data["remark"] = this.remark;
        return data; 
    }

    clone(): StationRecordDto_WithRelation {
        const json = this.toJSON();
        let result = new StationRecordDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IStationRecordDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    monitorDate: Date | undefined;
    stationId: number | undefined;
    recordId: number | undefined;
    remark: string | undefined;
}

export class StationRecordDto_Create implements IStationRecordDto_Create {
    id: number | undefined;
    monitorDate: Date | undefined;
    stationId: number | undefined;
    recordId: number | undefined;
    remark: string | undefined;

    constructor(data?: IStationRecordDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.monitorDate = data["monitorDate"] ? new Date(data["monitorDate"].toString()) : <any>undefined;
            this.stationId = data["stationId"];
            this.recordId = data["recordId"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): StationRecordDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new StationRecordDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["monitorDate"] = this.monitorDate ? this.monitorDate.toISOString() : <any>undefined;
        data["stationId"] = this.stationId;
        data["recordId"] = this.recordId;
        data["remark"] = this.remark;
        return data; 
    }

    clone(): StationRecordDto_Create {
        const json = this.toJSON();
        let result = new StationRecordDto_Create();
        result.init(json);
        return result;
    }
}

export interface IStationRecordDto_Create {
    id: number | undefined;
    monitorDate: Date | undefined;
    stationId: number | undefined;
    recordId: number | undefined;
    remark: string | undefined;
}

export class StationRecordDto_Update implements IStationRecordDto_Update {
    id: number | undefined;
    monitorDate: Date | undefined;
    stationId: number | undefined;
    recordId: number | undefined;
    remark: string | undefined;

    constructor(data?: IStationRecordDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.monitorDate = data["monitorDate"] ? new Date(data["monitorDate"].toString()) : <any>undefined;
            this.stationId = data["stationId"];
            this.recordId = data["recordId"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): StationRecordDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new StationRecordDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["monitorDate"] = this.monitorDate ? this.monitorDate.toISOString() : <any>undefined;
        data["stationId"] = this.stationId;
        data["recordId"] = this.recordId;
        data["remark"] = this.remark;
        return data; 
    }

    clone(): StationRecordDto_Update {
        const json = this.toJSON();
        let result = new StationRecordDto_Update();
        result.init(json);
        return result;
    }
}

export interface IStationRecordDto_Update {
    id: number | undefined;
    monitorDate: Date | undefined;
    stationId: number | undefined;
    recordId: number | undefined;
    remark: string | undefined;
}

export enum Booktype {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum StampType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum BookDto_CreateBookType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum BookDto_WithRelationBookType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum BookDtoBookType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum BookDto_GetAllByTypeBookType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum BookDto_UpdateBookType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum RecordTimeStampDto_WithRelationRecordType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum RecordTimeStampDto_CreateRecordType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum RecordTimeStampDto_UpdateRecordType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum FormStationRecordDtoRecordStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum FormFormalFrequence {
    _0 = 0, 
    _1 = 1, 
}

export enum FormItemType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}